/*
 * types/services/dr2am.locales.proto
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: version not set
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.21
 *
 * Do not edit the class manually.
 *
 */

import {ApiClient} from '../ApiClient';
import {PbResponseState} from './PbResponseState';

/**
 * The ServiceRemoveLocaleNameSpaceResponse model module.
 * @module model/ServiceRemoveLocaleNameSpaceResponse
 * @version version not set
 */
export class ServiceRemoveLocaleNameSpaceResponse {
  /**
   * Constructs a new <code>ServiceRemoveLocaleNameSpaceResponse</code>.
   * @alias module:model/ServiceRemoveLocaleNameSpaceResponse
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ServiceRemoveLocaleNameSpaceResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ServiceRemoveLocaleNameSpaceResponse} obj Optional instance to populate.
   * @return {module:model/ServiceRemoveLocaleNameSpaceResponse} The populated <code>ServiceRemoveLocaleNameSpaceResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ServiceRemoveLocaleNameSpaceResponse();
      if (data.hasOwnProperty('state'))
        obj.state = PbResponseState.constructFromObject(data['state']);
    }
    return obj;
  }
}

/**
 * @member {module:model/PbResponseState} state
 */
ServiceRemoveLocaleNameSpaceResponse.prototype.state = undefined;


